var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "preorder" },
    [
      _vm._t("default", null, {
        isVisible: _vm.isVisible,
        iFrameLoaded: _vm.iFrameLoaded,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }